export const OrderCI_ORDERDETAIL_STATE_PATH = 'orderDetail';

export class OrderDetailModel {
	id: number;
	documentId: string;
	formType?: string;
	schema: string;
	state?: number;
	stateEnum: string;
	revised: boolean;
	description?: string;
	deleted?: boolean;
	externalId?: string;
	externalProvider?: string;
	externalProductName?: string;
	locked?: Date;
	lockedBy?: OrderLockedBy;
	isCMPForm?: boolean;

	constructor() {
		this.documentId = '';
		this.formType = undefined;
		this.schema = '';
		this.state = undefined;
		this.stateEnum = '';
		this.revised = false;
		this.description = undefined;
		this.deleted = undefined;
		this.externalId = undefined;
		this.externalProvider = undefined;
		this.locked = undefined;
		this.lockedBy = new OrderLockedBy();
	}
}

export class OrderLockedBy {
	firstName: string | null;
	id: string | null;
	lastName: string | null;

	constructor() {
		this.firstName = null;
		this.id = null;
		this.lastName = null;
	}
}
